import { render, staticRenderFns } from "./SessionAttachments.vue?vue&type=template&id=8c304a9a&"
import script from "./SessionAttachments.vue?vue&type=script&lang=js&"
export * from "./SessionAttachments.vue?vue&type=script&lang=js&"
import style0 from "./SessionAttachments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports